export const RECEIVERS_MANAGEMENT_ACTIONS = {
  GET_RECEIVERS: 'GET_RECEIVERS',
  GET_RECEIVERS_SUCCESS: 'GET_RECEIVERS_SUCCESS',
  GET_RECEIVERS_ERROR: 'GET_RECEIVERS_ERROR',

  DELETE_RECEIVER: 'DELETE_RECEIVER',
  DELETE_RECEIVER_SUCCESS: 'DELETE_RECEIVER_SUCCESS',
  DELETE_RECEIVER_ERROR: 'DELETE_RECEIVER_ERROR',
  DELETE_RECEIVER_CLEAN_STATE: 'DELETE_RECEIVER_CLEAN_STATE',
  RESET_RECEIVER_NEXT_ALARM: 'RESET_RECEIVER_NEXT_ALARM',
};
// =========================================================================
export const resetReceiverNextAlarm = () => ({
  type: RECEIVERS_MANAGEMENT_ACTIONS.RESET_RECEIVER_NEXT_ALARM,
});
export const getReceivers = () => ({
  type: RECEIVERS_MANAGEMENT_ACTIONS.GET_RECEIVERS,
});
export const getReceiversSuccess = (params) => ({
  type: RECEIVERS_MANAGEMENT_ACTIONS.GET_RECEIVERS_SUCCESS,
  payload: params,
});
export const getReceiversError = () => ({
  type: RECEIVERS_MANAGEMENT_ACTIONS.GET_RECEIVERS_ERROR,
});
// =========================================================================
export const deleteReceiver = (data, callback = () => {}) => ({
  type: RECEIVERS_MANAGEMENT_ACTIONS.DELETE_RECEIVER,
  payload: data,
  callback,
});
export const deleteReceiverSuccess = (data) => ({
  type: RECEIVERS_MANAGEMENT_ACTIONS.DELETE_RECEIVER_SUCCESS,
  payload: data,
});
export const deleteReceiverError = ({ message }) => ({
  type: RECEIVERS_MANAGEMENT_ACTIONS.DELETE_RECEIVER_ERROR,
  payload: message,
});
export const deleteReceiverCleanState = () => ({
  type: RECEIVERS_MANAGEMENT_ACTIONS.DELETE_RECEIVER_CLEAN_STATE,
});
// =========================================================================
